import { render } from "./FlashSalePage.vue?vue&type=template&id=2e4454d2&scoped=true"
import script from "./FlashSalePage.vue?vue&type=script&lang=js"
export * from "./FlashSalePage.vue?vue&type=script&lang=js"

import "./FlashSalePage.vue?vue&type=style&index=0&id=2e4454d2&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1728185854/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e4454d2"]])

export default __exports__